import { createSlice } from "@reduxjs/toolkit";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";
import {
    Call,
    CallWithFormData,
    CallWithFormDataFile,
    cleanEmpty,
    downloadBlob,
    objectToFormData,
} from "../../../helpers/fetch";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import dayjs from "dayjs";
import "dayjs/locale/es";
dayjs.locale("es");

const initialState = {
    pagination: {
        data: [],
        per_page: 10,
    },
    openModal: false,
    receipt: null,
    response: null,
    overduePortfolio: null,
    openModalAccount: false,
};

export const paymentScreen = createSlice({
    name: "paymentScreen",
    initialState,
    reducers: {
        setPayments: (state, action) => {
            state.pagination = action.payload;
        },
        setOpenModal: (state) => {
            state.openModal = true;
        },
        setCloseModal: (state) => {
            state.openModal = false;
        },
        setOpenModalAccount: (state) => {
            state.openModalAccount = true;
        },
        setCloseModalAccount: (state) => {
            state.openModalAccount = false;
            state.response = null;
        },
        setReceipt: (state, action) => {
            state.receipt = action.payload;
        },
        setResponse: (state, action) => {
            state.response = action.payload;
        },
        setOverduePortfolio: (state, action) => {
            state.overduePortfolio = action.payload;
        },
        setCleanOverduePortfolio: (state) => {
            state.overduePortfolio = null;
        },
    },
});

export const {
    setPayments,
    setOpenModal,
    setCloseModal,
    setOpenModalAccount,
    setCloseModalAccount,
    setResponse,
    setCleanOverduePortfolio,
    setOverduePortfolio,
    setReceipt,
} = paymentScreen.actions;

export default paymentScreen.reducer;

export const startShow = (values) => {
    return async (dispatch, getState) => {
        dispatch(startUILoading());
        const params = new URLSearchParams();
        if (values?.page) {
            params.set("page", values.page);
        }
        if (values?.query) {
            params.set("q", values.query);
        }
        if (values?.number_rows) {
            params.set("per_page", values.number_rows);
        }
        if (values?.from) {
            params.set("from", values.from);
        }
        if (values?.to) {
            params.set("to", values.to);
        }
        if (values?.country) {
            params.set("country", values.country);
        }
        if (values?.academic_record_id) {
            params.set("academic_record_id", values.academic_record_id);
        }
        if (values?.invoice_status) {
            params.set("invoice_status", values.invoice_status);
        }
        if (values?.payable_type) {
            params.set("payable_type", values.payable_type);
        }
        if (values?.payment_method) {
            params.set("payment_method", values.payment_method);
        }
        if (values?.fiscal_cut !== undefined && values.fiscal_cut !== "") {
            params.set("fiscal_cut", values.fiscal_cut);
        }
        if (values?.fiscal_cut !== undefined && values.fiscal_cut !== "") {
            params.set("fiscal_cut", values.fiscal_cut);
        }
        if (values?.category) {
            params.set("category", values.category);
        }
        if (values?.month) {
            params.set("months", dayjs(values.month).format("MMMM - YYYY"));
        }
        if (values?.year) {
            params.set("year", values.year);
        }
        if (values?.is_export) {
            params.set("export", values.is_export);
        }
        if (values?.concepts) {
            params.set("concepts", 1);
        }

        const { session } = getState().auth;
        let url = "";

        if (session === "operator") {
            url = "services/payments/show";
        } else {
            url = "services/payments/show/student";
        }

        if (values.is_export) {
            const resp = await CallWithFormDataFile(
                url,
                "GET",
                params.toString()
            );

            downloadBlob(
                resp,
                values?.concepts
                    ? "Reporte de pagos por concepto.xlsx"
                    : "Reporte de pagos.xlsx"
            );
        } else {
            const resp = await Call(url, "GET", params.toString());

            if (resp.success) {
                dispatch(setPayments(resp.success.payments));
            }
        }
        dispatch(stopUILoading());
    };
};
export const startShowPaymentHistory = (values) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        const params = new URLSearchParams();
        params.set("page", values.page);
        params.set("q", values.query);
        params.set("per_page", values.number_rows);
        if (values.from) {
            params.set("from", values.from);
        }
        if (values.to) {
            params.set("to", values.to);
        }
        if (values.country) {
            params.set("country", values.country);
        }
        if (values.academic_record_id) {
            params.set("academic_record_id", values.academic_record_id);
        }

        // const resp = await Call(
        //     `services/payu/get/payment/academic_record`,
        //     "GET",
        //     params.toString()
        // );

        const resp = await Call(
            `services/payments/get/academic_record`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setPayments(resp.success));
        }
        dispatch(stopUILoading());
    };
};

export const startExportExcel = (
    query,
    from,
    to,
    country,
    payable_type,
    payment_method,
    fiscal_cut,
    invoice_status
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const values = {
            from: from,
            to: to,
            country: country,
            payable_type,
            payment_method,
            fiscal_cut,
            invoice_status,
        };
        let formData = new FormData();

        if (query) {
            formData.append("q", query);
        }
        formData.append("from", from);
        formData.append("to", to);
        formData.append("country", country);
        formData.append("payable_type", payable_type);
        formData.append("payment_method", payment_method);
        if (fiscal_cut !== undefined && fiscal_cut !== "") {
            formData.append("fiscal_cut", fiscal_cut);
        }
        if (invoice_status) {
            formData.append("invoice_status", invoice_status);
        }

        const resp = await CallWithFormDataFile(
            `services/payments/export`,
            "POST",
            formData
        );

        downloadBlob(resp, `Reporte cobranza.xlsx`);
        dispatch(stopUILoading());
    };
};

export const startExportExcelAll = () => {
    return async (dispatch, getState) => {
        dispatch(startUILoading());

        const { tiny_name } = getState().config;

        let formData = new FormData();

        formData.append("export", true);

        const resp = await CallWithFormDataFile(
            `services/payments/export-with-concepts`,
            "POST",
            formData
        );

        downloadBlob(
            resp,
            `Reporte cobranza general con conceptos ${tiny_name}.xlsx`
        );
        dispatch(stopUILoading());
    };
};

export const startGetOverduePortfolio = ({
    is_export,
    cycle,
    period,
    month,
    status_payment,
    curricula,
    status,
    degree,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        let formData = new FormData();

        formData.append("export", is_export ? 1 : 0);
        formData.append("cycle", cycle.name);
        if (period) {
            formData.append("period", period);
        }
        formData.append("status", status.map((s) => s.value).join(","));
        formData.append("curricula", curricula.map((c) => c.value).join(","));
        formData.append("degree", degree.map((d) => d.value).join(","));

        if (status_payment) {
            formData.append(
                "status_payment",
                status_payment.map((s) => s.value).join(",")
            );
        }

        if (month.length > 0) {
            formData.append(
                "month",
                month.map((m) => dayjs(m).format("MMMM - YYYY")).join(",")
            );
        }

        const url = `operators/reports/payments/overdue_portfolio`;

        if (!is_export) {
            const resp = await CallWithFormData(url, "POST", formData);
            dispatch(setOverduePortfolio(resp.success));
        } else {
            const resp = await CallWithFormDataFile(url, "POST", formData);
            downloadBlob(resp, `Reporte de pagos vencidos.xlsx`);
        }

        dispatch(stopUILoading());
    };
};

export const starUpdateAccounts = () => {
    return async (dispatch) => {
        const result = await Swal.fire({
            title: "¿Estas seguro que deseas actualizar los estados de cuenta?",
            icon: "warning",
            text: "Una vez realizado el movimiento no podrás revertir los cambios",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "¡Si, actualizar ahora!",
            confirmButtonColor: "#2e4a6c",
            cancelButtonColor: "#6c757d",
            allowOutsideClick: false,
            allowEnterKey: false,
            allowEscapeKey: false,
        });

        if (result.isConfirmed) {
            dispatch(startUILoading());
            const resp = await Call(
                `operators/students/account-status/update/massive`,
                "POST"
            );

            if (resp.success) {
                dispatch(setResponse(resp.success));

                Swal.fire({
                    title: "Éxito",
                    text: "Se actualizaron los estados de cuenta.",
                    icon: "success",
                    toast: true,
                    position: "bottom-end",
                    timer: 8000,
                });
            }

            dispatch(stopUILoading());
        }
    };
};

export const starUpdateAccountsByCycle = (cycle_id, callback = () => {}) => {
    return async (dispatch) => {
        const result = await Swal.fire({
            title: "¿Estas seguro que deseas actualizar los estados de cuenta de este ciclo?",
            icon: "warning",
            text: "Una vez realizado el movimiento no podrás revertir los cambios",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "¡Si, actualizar ahora!",
            confirmButtonColor: "#2e4a6c",
            cancelButtonColor: "#6c757d",
            allowOutsideClick: false,
            allowEnterKey: false,
            allowEscapeKey: false,
        });

        if (result.isConfirmed) {
            dispatch(startUILoading());

            let formData = new FormData();

            formData.append("cycle_id", cycle_id);

            const resp = await Call(
                `operators/students/account-status/update/cycle`,
                "POST",
                { cycle_id }
            );

            if (resp.success) {
                callback();
                Swal.fire({
                    title: "Éxito",
                    text: "Se actualizaron los estados de cuenta.",
                    icon: "success",
                    toast: true,
                    position: "bottom-end",
                    timer: 8000,
                });
            }

            dispatch(stopUILoading());
        }
    };
};

export const starImportEXP = (exp) => {
    return async (dispatch) => {
        const result = await Swal.fire({
            title: "¿Estás seguro que deseas importar este archivo?",
            icon: "warning",
            text: "Una vez realizado el movimiento no podrás revertir los cambios",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "¡Sí, importar ahora!",
            confirmButtonColor: "#2e4a6c",
            cancelButtonColor: "#6c757d",
            allowOutsideClick: false,
            allowEnterKey: false,
            allowEscapeKey: false,
        });

        if (result.isConfirmed) {
            dispatch(startUILoading());

            let formData = new FormData();

            formData.append("exp", exp);

            const resp = await CallWithFormData(
                `services/bbva/import/exp`,
                "POST",
                formData
            );

            if (resp.success) {
                dispatch(setCloseModalAccount());

                const { msg, payments_imported_count } = resp.success;

                Swal.fire({
                    title: msg,
                    text: `Pagos importados: ${payments_imported_count}`,
                    icon: "success",
                    timer: 10000,
                });
            } else {
                errorHandler(resp);
            }

            dispatch(stopUILoading());
        }
    };
};

export const startGenerateReceipt = (payment_id) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        const resp = await Call(`services/payments/by/${payment_id}`, "GET");
        if (resp.success) {
            dispatch(setReceipt(resp.success));
        }
        dispatch(stopUILoading());
    };
};

export const startUpdateFiscalCut = (values, callback = () => {}) => {
    return async (dispatch) => {
        const random = Math.floor(Math.random() * 100);
        Swal.fire({
            title: "¿Desea modificar el tipo de corte?",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Sí, modificar",
            confirmButtonColor: "#2e4a6c",
            cancelButtonColor: "#6c757d",
            input: "text",
            html: `
                <div style="font-size: 24px">Código:</div>
                <h4 id="swal-input1" class="h4" style="font-size: 26px; font-weight: bold; color: #005AA7">${random}</h4>
            `,
            inputLabel: `Introduzca el código mostrado para confirmar esta operación.`,
            inputAttributes: {
                autocapitalize: "off",
                placeholder: "Introduzca el código",
            },
            allowOutsideClick: false,
            allowEnterKey: false,
            width: 510,
        }).then(async (result) => {
            if (parseInt(result.value) === random) {
                dispatch(startUILoading());

                const resp = await Call(
                    `services/payments/update-fiscal-cut`,
                    "PUT",
                    values
                );

                if (resp.success) {
                    Swal.fire({
                        title: "Éxito",
                        text: "Se actualizó el tipo de corte.",
                        icon: "success",
                        toast: true,
                        position: "bottom-end",
                        timer: 8000,
                    });

                    callback();
                } else {
                    errorHandler(resp);
                }

                dispatch(stopUILoading());
            } else {
                Swal.fire({
                    title: "Error",
                    text: "El código de confirmación ingresado es incorrecto.",
                    icon: "warning",
                    width: 420,
                });
            }
        });
    };
};
